<template>
    <div class="modal-content">
        <div class="modal-body">
            <div class="delete_acc_txt_cl">
                <h4>{{ $t('do-you-want-to-delete-account', 'Do you want to delete account') }}?</h4>
                <div class="delete_acc_btn">
                    <button  @click="$emit('close')" type="button" id="closeBtn" class="cmn_ftr_btn cancel_btn_cl" data-bs-dismiss="modal">{{ $t('cancel', 'Cancel') }}</button>
                    <button @click="$emit('yes-click')" type="button" class="cmn_ftr_btn yes_btn_cl">{{ $t('yes', 'Yes') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DeleteAccount',
    props: ['item'],
    emits: ['close', 'yes-click'],    
};
</script>